/**
 * @example
 * ```ts
 * const $list = listFactory('and')
 * $list(['foo', 'bar', 'baz']) // => 'foo, bar and baz'
 * ```
 */
export const listFactory = (conjunction: string) => {
  return (items: string[]) => {
    return items
      .map((item, i) => {
        return `${
          i === 0 ? '' : i === items.length - 1 ? ` ${conjunction} ` : ', '
        }${item}`
      })
      .join('')
  }
}
